export const styles = theme => ({
  root: {
    padding: 7
  },
  textButton: {
    padding: "0 8px",
    minWidth: 0,
    fontWeight: "bold"
  },
  lightTooltip: {
    backgroundColor: "white",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11
  },
  tooltip: {
    maxWidth: 500
  }
});
